module.exports = __webpack_public_path__ + "img/flower_rui.ebc19cf3.png";